package cz.lhoracek.mapl.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

// Mariáš-inspired palette
private val Green800 = Color(0xFF1B5E20)
private val Green600 = Color(0xFF2E7D32)
private val Green400 = Color(0xFF66BB6A)
private val Green200 = Color(0xFFA5D6A7)
private val Green100 = Color(0xFFC8E6C9)
private val Orange700 = Color(0xFFE65100)
private val Orange100 = Color(0xFFFFE0B2)
private val Red900 = Color(0xFFB71C1C)
private val Red100 = Color(0xFFFFCDD2)
private val SurfaceWarm = Color(0xFFFFFBF0)
private val SurfaceVariant = Color(0xFFF1EBD8)
private val SurfaceDark = Color(0xFF121510)
private val SurfaceDarkVariant = Color(0xFF262B24)

private val MaplLightColors = lightColorScheme(
    primary = Green800,
    onPrimary = Color.White,
    primaryContainer = Green100,
    onPrimaryContainer = Color(0xFF002106),
    secondary = Orange700,
    onSecondary = Color.White,
    secondaryContainer = Orange100,
    onSecondaryContainer = Color(0xFF2E1500),
    tertiary = Red900,
    onTertiary = Color.White,
    tertiaryContainer = Red100,
    onTertiaryContainer = Color(0xFF3B0007),
    surface = SurfaceWarm,
    surfaceVariant = SurfaceVariant,
    onSurface = Color(0xFF1A1C18),
    onSurfaceVariant = Color(0xFF43483F),
    background = SurfaceWarm,
    onBackground = Color(0xFF1A1C18),
)

private val MaplDarkColors = darkColorScheme(
    primary = Green400,
    onPrimary = Color(0xFF00390A),
    primaryContainer = Green800,
    onPrimaryContainer = Green200,
    secondary = Orange100,
    onSecondary = Color(0xFF4A2800),
    secondaryContainer = Orange700,
    onSecondaryContainer = Orange100,
    tertiary = Red100,
    onTertiary = Color(0xFF5F1111),
    tertiaryContainer = Red900,
    onTertiaryContainer = Red100,
    surface = SurfaceDark,
    surfaceVariant = SurfaceDarkVariant,
    onSurface = Color(0xFFE1E3DC),
    onSurfaceVariant = Color(0xFFC3C8BC),
    background = SurfaceDark,
    onBackground = Color(0xFFE1E3DC),
)

@Composable
fun MaplTheme(
    darkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit,
) {
    MaterialTheme(
        colorScheme = if (darkTheme) MaplDarkColors else MaplLightColors,
        content = content,
    )
}
